// Hover-to-open desktop menus for Dawn (safe: no effect on mobile)
document.addEventListener('DOMContentLoaded', function () {
  const desktopQuery = window.matchMedia('(min-width: 990px)');

  function wireHoverMenus() {
    // Dawn uses <details id="Details-HeaderMenu-..."> for top-level items
    const menuDetails = document.querySelectorAll('header details[id^="Details-HeaderMenu-"]');
    menuDetails.forEach((d) => {
      // Clean previous listeners (if hot-reloaded)
      d.onmouseenter = null;
      d.onmouseleave = null;

      d.addEventListener('mouseenter', () => {
        if (!desktopQuery.matches) return;
        // open on hover
        d.setAttribute('open', '');
      });

      d.addEventListener('mouseleave', () => {
        if (!desktopQuery.matches) return;
        // close when mouse leaves the details
        d.removeAttribute('open');
      });
    });
  }

  wireHoverMenus();
  // Re-apply if layout changes width
  window.addEventListener('resize', wireHoverMenus);
});
